import { render, staticRenderFns } from "./CobraTraining.vue?vue&type=template&id=49671ef2&"
import script from "./CobraTraining.vue?vue&type=script&lang=js&"
export * from "./CobraTraining.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports